import { StoryList, StoryPeerType } from '@weblite/ts-action/story'
import { DateString } from '@weblite/ts-action'

export type StoryType = 'IMAGE' | 'VIDEO'
interface StoryElement {
  type: StoryType
  // posX, posY, height or scale, rotation
}
export interface SEImage extends StoryElement {
  type: 'IMAGE'
  /* base64Url */
  thumbnail: string
  fileId: string
  // for story that uploaded just now
  fileUrl?: string
}
export interface SEVideo extends StoryElement {
  type: 'VIDEO'
  /* base64Url */
  thumbnail: string
  coverId: string
  fileId: string
  // for story that uploaded just now
  fileUrl?: string
  duration?: number
}
export type StoryContentItem = SEImage | SEVideo
export type StoryContent = StoryContentItem[]

export interface StoryRibbon extends StoryList {
  nonSubscribed?: boolean
  priority: StoryRibbonPriority
}

export type StoryUploadStatus = 'UPLOADING' | 'COMPRESSING' | 'SENDING'

interface UploadingFile {
  uploadId: string
  file: File
  fileUrl: string
  thumbnail: string
  uploadPercent?: number
  uploadStatus: StoryUploadStatus
  fileId?: string
  peerId: string
  peerType: StoryPeerType
  uploadStartedAt: DateString
}

export interface UploadingImage extends UploadingFile {
  type: 'IMAGE'
}

export interface UploadingVideo extends UploadingFile {
  compressionPercent?: number
  cover: File
  coverUploadId: string
  coverFileId?: string
  type: 'VIDEO'
  duration?: number
}

export type UploadingStory = UploadingImage | UploadingVideo

export type UpdateUploadData =
  | {
      uploadId: string
      uploadPercent?: number
      uploadStatus?: StoryUploadStatus
      fileId?: string
      thumbnail?: string
    }
  | {
      uploadId: string
      uploadPercent?: number
      uploadStatus?: StoryUploadStatus
      compressionPercent?: number
      fileId?: string
      coverFileId?: string
    }

export type AddStoryToStoriesPayload = {
  peerId: string
  peerType: StoryPeerType
  storyId: string
}

export interface AddStoryToRibbonPayload extends AddStoryToStoriesPayload {
  lastStoryAt: DateString
  priority: StoryRibbonPriority
}

export enum StoryAnalyticsEvents {
  STORY_CREATE = 'STORY_CREATE',
  STORY_REMOVE = 'STORY_REMOVE',
  STORY_VIEWER_LIST_CLICK = 'STORY_VIEWER_LIST_CLICK',
  STORY_MUTE_CLICK = 'STORY_MUTE_CLICK',
  STORY_PROFILE_CLICK = 'STORY_PROFILE_CLICK',
  STORY_SWIPE = 'STORY_SWIPE',
  STORY_OPEN = 'STORY_OPEN',
}

export enum StoryRibbonPriority {
  INFINITY = Infinity,
  UPLOADING = 100,
  NOT_VIEWED = 10,
  BASE = 1,
}
